export default "__VITE_ASSET__BUV5BHqs__"